<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="Рекомендательные письма" name="1">
      <RecommendationLetters />
    </el-collapse-item>
    <el-collapse-item title="В составе брокерских палат ..." name="2">
      <BrokerageHouses />
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import RecommendationLetters from 'components/BrandHistory/RecommendationLetters'
import BrokerageHouses from 'components/BrandHistory/BrokerageHouses'

export default {
  name: 'BrandHistory',
  data () {
    return {
      activeNames: ['1', '2']
    }
  },
  components: { RecommendationLetters, BrokerageHouses }
}
</script>

<style scoped>
.el-collapse-item {
  width: 100%;
}
.is-active {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// BrandRecommendations.vue?de9a5df6